import React, { useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';

import styled from 'styled-components';

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { useTranslation } from 'react-i18next';

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
);

/**
 * * 압축 파일 드롭존
 */

const DropZoneZip = (props) => {
  const { t } = useTranslation();
  const { zipMemo, id, setFile, value } = props;
  const [files, setFiles] = useState();

  /** 압축 파일 보내기 */
  const onupdatefiles = (fileData) => {
    // console.log(fileData[0].file);
    if (fileData.length === 0) {
      return;
    } else {
      setFile(fileData[0].file);
    }
  };
  return (
    <Wrap>
      <FilePond
        acceptedFileTypes={['application/zip', 'application/x-zip-compressed']}
        file={files}
        allowMultiple={false}
        onupdatefiles={onupdatefiles}
        labelIdle={`${t(
          'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.registerBackgroundZipModal.dragAndDrop1',
        )} <br /> ${t(
          'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.registerBackgroundZipModal.dragAndDrop2',
        )}`}
        // labelIdle={props.zipMemo !==true && "<span>zip 형식의 압축 파일을 끌어놓거나 <br /> 클릭하여 zip 파일을 선택해 주세요.</span>"}
      />
      <Notice
        style={{
          fontSize: '12px',
          textAlign: 'left',
          color: '#878787',
          marginTop: '0.3rem',
        }}
      >
        {zipMemo !== 'live2d' && (
          <li>
            {t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.registerBackgroundZipModal.unsupportedFiles1',
            )}
          </li>
        )}

        <li>
          {t(
            'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.registerBackgroundZipModal.unsupportedFiles2',
          )}
        </li>
      </Notice>
    </Wrap>
  );
};

export default DropZoneZip;
const Wrap = styled.div`
  .filepond--root {
    width: 100%;
    /* border: solid 2px red; */
  }
`;

const Notice = styled.ul`
  margin-left: 1rem;
  font-size: 12px;
  text-align: left;
  color: #878787;
  margin-top: 9px;
`;
